// Endpoint probe matrix — table of every GymSales endpoint we hit with
// its current live status (200/302/404/etc.), latency, and notes.
import React from 'react';
import { Search } from 'lucide-react';
import { StatusPill } from './shared';

const ProbeMatrix = ({ probes, isRetesting }) => (
  <div className="bg-white/[0.03] border border-white/10 rounded-xl overflow-hidden mb-4">
    <div className="px-4 py-3 border-b border-white/10 flex items-center gap-2 text-white font-semibold text-sm">
      <Search className="w-4 h-4 text-emerald-400" />
      Endpoint probe matrix
      <span className="text-xs text-white/40 font-normal">— fired {isRetesting ? 'now' : 'on load / re-test'}</span>
    </div>
    <table className="w-full text-sm" data-testid="gymsales-probe-matrix">
      <thead>
        <tr className="bg-black/20 text-white/50 text-[10px] uppercase tracking-widest">
          <th className="text-left px-3 py-2 font-semibold">Label</th>
          <th className="text-left px-3 py-2 font-semibold">Path</th>
          <th className="text-center px-3 py-2 font-semibold">Status</th>
          <th className="text-right px-3 py-2 font-semibold">Latency</th>
          <th className="text-left px-3 py-2 font-semibold">Notes</th>
        </tr>
      </thead>
      <tbody>
        {probes.map((p) => (
          <tr key={p.path} className="border-t border-white/5 hover:bg-white/5" data-testid={`probe-${p.path}`}>
            <td className="px-3 py-2 text-white/90">{p.label}</td>
            <td className="px-3 py-2 text-white/60 font-mono text-[11px]">{p.path}</td>
            <td className="px-3 py-2 text-center"><StatusPill code={p.status_code} ok={p.ok} /></td>
            <td className="px-3 py-2 text-right text-white/60 tabular-nums text-xs">{Math.round(p.duration_ms)}ms</td>
            <td className="px-3 py-2 text-white/50 text-[11px]">
              {p.notes}
              {p.error && <div className="text-rose-300 mt-0.5">{p.error}</div>}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default ProbeMatrix;
